import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

export { SwappedTypography }

type Props = {
  oldText: string
  newText: string
  reason: string
}

const SwappedTypography = ({ oldText, newText, reason }: Props) => {
  return (
    <Tooltip title={reason}>
      <Typography
        sx={{
          display: 'inline-flex',
          alignSelf: 'flex-start',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 0.5,
        }}
      >
        <Typography
          component="span"
          sx={{ textDecoration: 'line-through', opacity: 0.6 }}
        >
          {oldText}
        </Typography>

        <SwapHorizIcon />

        <Typography component="span">{newText}</Typography>
      </Typography>
    </Tooltip>
  )
}
